var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.320312,
    y: 0.800781,
    width: 350,
    height: 233,
    fill: "#2E4491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.309 138.432L228.103 170.828L298.481 139.178L204.414 102.535L140.309 138.432Z",
    fill: "#300901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.17 131.645L244.236 163.673L299.802 138.977L208.736 106.949L153.17 131.645Z",
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.838 115.558L244.103 144.487L288.556 124.663L208.291 95.7344L163.838 115.558Z",
    fill: "#373943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.348 100.517L288.613 129.446L288.613 121.214L208.348 92.2852L208.348 100.517Z",
    fill: "#4A4D5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.341 100.499L163.944 120.304L163.943 112.09L208.341 92.2852L208.341 100.499Z",
    fill: "#202129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.34 100.499L206.348 101.39L202.047 95.084L208.34 92.2852L208.34 100.499Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.342 100.499L283.947 127.813V119.421L208.342 92.2852L208.342 100.499Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.339 100.5L279.821 126.273L277.025 127.277L206.352 101.393L208.339 100.5Z",
    fill: "#21232C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.236 145.149L153.17 113.122L208.736 88.4258L299.802 120.453L244.236 145.149ZM244.162 141.037L163.898 112.108L208.35 92.2841L288.615 121.213L244.162 141.037Z",
    fill: "#FFD6CD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.236 145.149L153.17 113.122L208.736 88.4258L299.802 120.453L244.236 145.149ZM244.162 141.037L163.898 112.108L208.35 92.2841L288.615 121.213L244.162 141.037Z",
    fill: "url(#paint0_linear_569_27165)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.17 113.125L244.236 145.147V163.675L153.17 131.647V113.125Z",
    fill: "#6A2213"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M299.802 120.453L244.236 145.148V163.671L299.802 138.975V120.453Z",
    fill: "#F7785C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.631 107.436L258.057 131.599L262.334 129.362L196.778 105.891L193.631 107.436Z",
    fill: "#21232C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.385 104.297L259.897 128.056L259.897 130.331L195.385 106.571L195.385 104.297Z",
    fill: "#6A68C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.385 104.295L259.897 128.054L262.478 126.709L197.966 102.949L195.385 104.295Z",
    fill: "#B8B7F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.971 120.115L259.894 127.772L262.475 126.426L241.552 118.77L238.971 120.115Z",
    fill: "#6E6BE2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246.152 122.442L255.597 125.979L257.043 125.228L247.598 121.691L246.152 122.442Z",
    fill: "#1C4664"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.38 127.367L259.148 126.841L260.595 126.09L260.89 126.527L259.38 127.367Z",
    fill: "#4745A9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.438 122.121L259.15 126.84L259.38 127.369L255.495 125.933L255.282 125.662L246.15 122.251L246.438 122.121Z",
    fill: "#6A68C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M246.438 122.122L259.149 126.841L260.595 126.09L247.883 121.371L246.438 122.122Z",
    fill: "#B8B7F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M246.433 122.122L246.162 122.246L247.609 121.495L247.88 121.371L246.433 122.122Z",
    fill: "#32688E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M259.896 130.667L259.895 127.771L262.476 126.426L262.477 129.322L259.896 130.667Z",
    fill: "#333180"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M238.971 120.113L259.903 127.792V130.689L238.971 122.968V120.113Z",
    fill: "#4745A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M281.33 128.646L281.33 124.385L289.664 120.742L298.484 121.091L281.33 128.646Z",
    fill: "#AE442E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M295.199 141.025L281.312 128.621L299.861 120.445L299.802 138.975L295.199 141.025Z",
    fill: "#300901"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.395 87.8579L281.659 116.787L324.379 115.273L244.114 86.3438L201.395 87.8579Z",
    fill: "#FFDBD3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.395 87.8579L281.659 116.787L324.379 115.273L244.114 86.3438L201.395 87.8579Z",
    fill: "url(#paint1_linear_569_27165)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.658 123.488V116.784L324.378 115.27L324.379 121.159L281.658 123.488Z",
    fill: "#F7785C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M281.669 123.509V116.805L201.395 87.8594L201.396 93.7488L281.669 123.509Z",
    fill: "#6A2213"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27165",
    x1: 266.691,
    y1: 105.373,
    x2: 256.605,
    y2: 132.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D1A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27165",
    x1: 270.005,
    y1: 90.2458,
    x2: 261.792,
    y2: 110.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE442E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7785C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool01);
export default __webpack_public_path__ + "static/media/school_01.acd6cc6da09b34054e83b4962fa03a1e.svg";
export { ForwardRef as ReactComponent };